const ProgressBar1 = () => {
	return (
		<svg
			width='150'
			height='4'
			viewBox='0 0 150 4'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<rect width='150' height='4' rx='2' fill='#E7E7E7' />
			<path
				d='M0 2C0 0.895431 0.89543 0 2 0H48C49.1046 0 50 0.895431 50 2V2C50 3.10457 49.1046 4 48 4H2C0.895432 4 0 3.10457 0 2V2Z'
				fill='#7E50FF'
			/>
		</svg>
	);
};

export default ProgressBar1;
